import { ApiUrls } from "appConstants/apis";
import { Partner } from "models/partner/Partner";
import { BaseServices } from "./baseServices";

export class PartnerService extends BaseServices<Partner> {
	constructor() {
		super(Partner);
	}

	getList(filters: any): any {
		try {
			return super
				.listPaginated(ApiUrls.partners.getList, filters)
				.then((response) => response);
		} catch (error) {
			return undefined;
		}
	}

	getPartnerDetails(id: string): any {
		return super
			.get(ApiUrls.partners.getPartnerDetails(id))
			.then((response) => {
				const partner = Partner.createFromResponse(response);
				return partner;
			});
	}

	getCategoriesOptions() {
		return super.get(ApiUrls.partners.category.getList);
	}
}
